import toDateObject from '../toDateObject';

// M?M/D?D; e.g., 12/1, 3/14, 3/1
const toDay = date => {
  const dateObj = toDateObject(date);

  return `${dateObj.getMonth() + 1}/${dateObj.getDate()}`;
};

export default toDay;